import React from 'react';
import styled from '@emotion/styled';
import './businessCard.scss';

import verticalDivider from '../../../assets/icons/verticalDivider.svg';
import grayPlusIcon from '../../../assets/icons/grayPlusIcon.svg';
import { STORE_ACTIVATE_STATUS } from 'constants/CONSTATNS';

const LockStore = styled.button`
  position: absolute;
  display: flex;
  top: 12px;
  left: 12px;
  right: 12px;
  bottom: 12px;
  align-items: center;
  justify-content: center;
`;
const LockImg = styled.img`
  z-index: 1;
`;
const LockBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 14px;
  background-color: #fff;
  opacity: 0.4;
`;

export interface IBusinessCard {
  storeSeq: string;
  storeSeqNumber: number;
  storeStatus: STORE_ACTIVATE_STATUS;
  storeName: string;
  employees: number;
  duty: number;
  onClick: (store: IBusinessCard) => void;
}

const BusinessCard = (props: IBusinessCard) => {
  const { storeSeq, storeStatus, storeName, employees, duty, onClick } = props;

  const nf = new Intl.NumberFormat();
  return (
    <div className="businessCard">
      {storeStatus === 'disabled' && (
        <LockStore onClick={() => onClick(props)}>
          <LockImg src={require('assets/images/lockIcon.png')} />
          <LockBg />
        </LockStore>
      )}
      <div className="cardWrap">
        <div className="header">{storeName}</div>
        <div className="detailContainer">
          <div className="leftDiv">
            <div className="detailHeader">직원수</div>
            <div className="detailContent">{nf.format(employees)}</div>
          </div>
          <div className="centerDivider">
            <img src={verticalDivider} alt="" />
          </div>
          <div className="rightDiv">
            <div className="detailHeader">근무중</div>
            <div className="detailContent">{nf.format(duty)}</div>
          </div>
        </div>

        <button className="enterStoreBtn" onClick={() => onClick(props)}>
          입장하기
        </button>
      </div>
    </div>
  );
};

const BusinessCardPlaceHolder = () => {
  return (
    <div className="businessCardPlaceholder">
      <div className="imageContainer">
        <img src={grayPlusIcon} alt="" />
      </div>
      <div className="textLabel">사업장 추가하기</div>
    </div>
  );
};

export { BusinessCard, BusinessCardPlaceHolder };
